<template>
    <div class=""> 
        <h5 class="text-center">Proyectos seleccionados por la sede para su aprobacion a oferta academica</h5>
        <v-row class="mt-1">  
            <v-col xs="2" sm="2" md="2" lg="2">
                <v-checkbox v-model="omitir_sede" color="blue" label="omitir sede" outlined dense :loading="loading"> </v-checkbox>
            </v-col>
            <v-col xs="2" sm="1">
                <v-btn color="blue" small outlined dark :loading="loading" @click="getDatos()"> <v-icon>mdi-refresh</v-icon> </v-btn>
            </v-col>
            <v-col xs="6" sm="4">
                <p class="my-0"> Sede: <b> {{ $store.state.CARGO.sede.nombre }} </b> </p> 
            </v-col>
        </v-row>
        <v-divider class="mt-0 mb-4" />

        <v-data-table
            :headers="headers"
            :items="desserts"
            :loading="loading" 
            dense
            disable-pagination 
            hide-default-footer
            :items-per-page="50"
            class="elevation-0">
    
            <template v-slot:[`item.ind`]="a">
                <span> {{ a.index + 1 }} </span>
            </template>
            <template v-slot:[`item.fecha_aprobacion`]="{item}">
                <span> {{ parseDateFecha(item.fecha_aprobacion, true) }} </span>
            </template> 
            <template v-slot:[`item.fecha_registro`]="{item}">
                <span> {{ parseDateFecha(item.fecha_registro, true) }} </span>
            </template>  
            <template v-slot:[`item.estado_aprobacion`]="{item}">
                <v-badge v-if="item.estado_aprobacion=='PENDIENTE'" dot color="orange" />
                <v-badge v-if="item.estado_aprobacion=='APROBADO'" dot color="green" />
                <v-badge v-if="item.estado_aprobacion=='RECHAZADO'" dot color="red" />
                <span> &nbsp;{{ item.estado_aprobacion }} </span> 
            </template> 
            <template v-slot:[`item.ultima_campania`]="{item}">
                <template v-if="item.ultima_campania">
                    <v-badge v-if="item.ultima_campania.estado=='solicitado'" dot color="orange" />
                    <v-badge v-else-if="item.ultima_campania.estado=='aprobado'" dot color="green" />
                    <v-badge v-else-if="item.ultima_campania.estado=='rechazado'" dot color="red" />
                    <v-badge v-else-if="item.ultima_campania.estado=='reprogramado'" dot color="purple" />
                    &nbsp;
                    {{ parseDateFecha(item.ultima_campania.fecha_inicio) }}
                    {{ parseDateFecha(item.ultima_campania.fecha_final) }}
                </template> 
            </template> 
            <template v-slot:[`item.ultima_reg_prog`]="{item}"> 
                <template v-if="item.ultima_reg_prog"> 
                    {{ parseDateFecha(item.ultima_reg_prog.fecha_inicio) }}
                    {{ parseDateFecha(item.ultima_reg_prog.fecha_final) }}
                </template> 
            </template> 
            <template v-slot:[`item.opt`]="{item}">
                <v-menu offset-x offset-y >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="my-0 py-0" color="primary" outlined small dark v-bind="attrs" v-on="on">
                            <v-icon>mdi-menu</v-icon>
                        </v-btn>
                    </template>
                    <v-list style="background-color: #162455;">
                        <v-list-item style="background: #00a082;" dark v-if="!item.aprobado_por_id" class="ma-1" link @click="aprobar(item)">
                            <v-list-item-title>
                                <v-icon small>mdi-check</v-icon>
                                <!-- {{item.aprobado_por_id?'Desaprobar':'Aprobar'}} -->
                                 Aprobar
                            </v-list-item-title>
                        </v-list-item>  
                        <v-list-item style="background: #a0000a;" dark class="ma-1" link @click="rechazar(item)">
                            <v-list-item-title>
                                <v-icon small>mdi-close</v-icon>
                                rechazar
                            </v-list-item-title>
                        </v-list-item>  
                        <v-list-item style="background: #1564be;" dark class="ma-1" v-if="item.ultima_campania" link @click="aprobar_campania(item)">
                            <v-list-item-title>
                                <v-icon small>mdi-flag</v-icon>
                                ver campaña
                            </v-list-item-title>
                        </v-list-item>  
                    </v-list>
                </v-menu> 
            </template>

        </v-data-table> 
 
        <seleccionarModal ref="refSeleccionarModal" />
        <rechazar_modal ref="refrechazar_modal" />
        <apro_recha_campania ref="refapro_recha_campania" />
    </div>
</template>
  
<script>
import seleccionarModal from './aprobar_modal.vue';
import rechazar_modal from './rechazar_modal.vue';
import apro_recha_campania from '../autoria_seleccionar/apro_recha_campania.vue';
import {parseFecha,parseDateFecha, meses} from '../util.ts'
import { seleccionados_dbs } from '@/views/oferta_academica/servicios/seleccionService.ts';

export default {
    components: {seleccionarModal,rechazar_modal,apro_recha_campania}, 
    data() {
        return {
            loading: false,
            headers: [ 
                { text: '#', value: 'ind' },
                { text: 'proyecto', value: 'nombre_proyecto', width:'350' },
                { text: 'para sede', value: 'sede_portal_name', width:'170' },
                { text: 'proyecto origen', value: 'sede_name', width:'170' }, 
                { text: 'lista', value: 'lista_de_oferta', width:'130' },
                { text: 'estado', value: 'estado_aprobacion', width:'130' }, 
                { text: 'fecha solicitud', value: 'fecha_registro' }, 
                { text: 'fecha aprob', value: 'fecha_aprobacion' }, 
                { text: 'reg prog portal', value: 'ultima_reg_prog', width:'130' },
                { text: 'campania', value: 'ultima_campania', width:'130' },
                { text: '', value: 'opt' },
            ],
            desserts: [],
            parseFecha,
            parseDateFecha,
            meses, 
            omitir_sede: false,
            tabs: null, 
            unidad_id: null,
        };
    },
    watch: {
        '$store.state.CARGO': function( ){  
            this.getDatos();
        }, 
    },
    methods: {
        async getDatos(){ 
            this.desserts = [];  
            const q = {
                sede_portal_id:this.$store.state.CARGO.sede.id,
                unidad_negocio_id:this.$store.state.CARGO.sede.unidad_negocio,
            }
            if(this.omitir_sede) delete q.sede_portal_id;
            const r = await seleccionados_dbs(q)
            if(r && r.seleccionados_dbs){
                this.desserts = r.seleccionados_dbs
            } 
            
        }, 

        aprobar_campania(item){
            window.console.log('item', item);
            this.$refs.refapro_recha_campania.openmodal(item);
        },

        aprobar(r){
            this.$refs.refSeleccionarModal.openmodal(r)
        },
        rechazar(r){
            this.$refs.refrechazar_modal.openmodal(r)
        }
        
    },
    mounted() { 
        this.unidad_id = this.$store.state.CARGO.sede.unidad_negocio
        if(this.unidad_id == 1){ 
            // estas fechas no les interesa a ESAM
            this.headers = this.headers.filter(x=>x.value != 'ultima_reg_prog')
        }
        this.getDatos();
    },
};
</script>
  